import { Group, ImageMantine } from 'ui';

const LOGO_URL = 'https://s3.amazonaws.com/com.givebacks.public/icons/TokenEx.png';
const Logo = () => {
  return (
    <Group justify="center" gap="xs" wrap="nowrap">
      <span className="font-medium text-gray-800 text-11 f-ic font-montserrat">
        Securely integrated with
      </span>
      <ImageMantine h={20} src={LOGO_URL} />
    </Group>
  );
};

export { Logo };
